import React, { useState } from "react";
import { Form, Row, Col, Modal, message, Button, Tooltip, Input, InputNumber } from "antd";
import Idame from "../components/ReportFormGenerator/Idame/Idame";
import liracrypt from "../components/Liracrypt/liracrypt";
import { CheckCircleOutlined, CopyOutlined } from "@ant-design/icons";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import SessionError from "../components/ApiErrorComp/SessionError";
import UniDropAdv from "../components/ReportFormGenerator/UniDrop/UniDropAdv";
import StAddNew from "./DSeries/StAddNew";
import ButtonPicker from "../components/ReportFormGenerator/Button/Button";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

function CreateExamSession({ setPageHeader, urlData }) {
  setPageHeader("Exam Session");
  const [form] = Form.useForm();
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [otp, setOtp] = useState("");
  const [smsLoading, setSmsLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);


  const copyOTP = () => {
    window.navigator.clipboard.writeText(otp).then(() => {
      message.success('Copied Successfully');
    }).catch(err => {
      message.error('Something went wrong');
      console.log(err);
    })
  }

  const onFinish = (values) => {

    setLoading(true);
    liracrypt
      .post("/qc/auditsession", {
        ...values,
        typ: "exam",
        _id: "Exm_002",
      })
      .then((res, req) => {
        setLoading(false);
        setOtp(res.data.data.otp);
        setModalVisible(true);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const sendOTP = (values) => {
    if (values.emailId) {
      setEmailLoading(true);
    }
    if (values.mobileNo) {
      setSmsLoading(true);
    }
    liracrypt.post('/createexamsession/sms/email', values)
      .then(response => {
        setSmsLoading(false);
        setEmailLoading(false);
        if (response.data.isSuccess) {
          message.success(response.data.message || 'OTP sent successfully');
        } else {
          message.error(response.data.message || 'Something went wrong');
        }
      }).catch(err => {
        setSmsLoading(false);
        setEmailLoading(false);
        ApiErrorComp();
        console.log(err);
      })
  }

  return (
    <>
      <SessionError visible={loginError} />
      <Modal
        title={
          <>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ marginRight: "20px", display: "flex" }}>
                <CheckCircleOutlined
                  style={{ fontSize: 30, color: "#08f269" }}
                />
              </div>
              <div
                style={{
                  margin: 0,
                  color: "#fff",
                  fontWeight: 600,
                  display: "flex",
                  fontSize: "20px",
                }}
              >
                Exam Session Created
              </div>
            </div>
          </>
        }
        open={modalVisible}
        style={{ fontWeight: 600 }}
        cancelButtonProps={{ hidden: true }}
        onCancel={() => setModalVisible(false)}
        onOk={() => {
          setModalVisible(false);
        }}
        okButtonProps={{ hidden: true }}
        okText={
          <h6
            style={{
              margin: 0,
              fontWeight: 800,
              fontSize: "0.9rem",
              color: "#fff",
            }}
          >
            OK
          </h6>
        }
      >
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
          <p
            style={{
              fontWeight: 300,
              color: "#fff",
              marginRight: "20px",
              fontSize: 25,
              marginBottom: 0
            }}
          >
            Your OTP Is :
          </p>
          <span style={{ color: "#08f289", fontSize: "3rem" }}>
            {otp}
          </span>
          <Tooltip title="Click To Copy">
            <Button style={{ marginLeft: 15 }} onClick={copyOTP} ghost={true} type="primary" icon={<CopyOutlined />}>{''}</Button>
          </Tooltip>
        </div>
        {/* <div
          className="AuditSection CreateAudit">
          <div className="ThemeForm">
            <Form
              onFinish={sendOTP}
              labelWrap={true}
              size="large"
              colon={false}>
              <Row>
                <Col span={18}>
                  <Form.Item labelCol={{ span: 8 }} name="mobileNo" label="Phone No" rules={[
                    {
                      required: true,
                      message: "Please enter phone number"
                    },
                    //  {
                    //   pattern: '@"^\d{10}$"',
                    //   message: 'Please enter a valid phone number'
                    // }
                  ]}>
                    <InputNumber minLength={10} maxLength={10} style={{ width: '100%' }} size={"large"}
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Button loading={smsLoading} htmlType="submit" size="large" type="primary">Send OTP</Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
        <div
          className="AuditSection CreateAudit">
          <div className="ThemeForm">
            <Form
              onFinish={sendOTP}
              size="large"
              colon={false}>
              <Row style={{ marginTop: 10 }}>
                <Col span={18}>
                  <Form.Item labelCol={{ span: 8 }} name="emailId" label="Email" rules={[
                    {
                      required: true,
                      message: "Please enter email"
                    },
                    {
                      pattern: '^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
                      message: 'Please enter valid email address'
                    }
                  ]}>
                    <Input type="email" />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Button loading={emailLoading} size="large" type="primary">Send OTP</Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div> */}
      </Modal >
      <div className='phantom-form query-form-container'>
        <StAddNew
          colSpan={12}
          initForm={form}
          formName="phantomSpecialQueryForm"
          // setSmodalConfig={(config) => { setQueryConfig(config) }}
          stopResetForm={true}
          urlEndpoint={"/miscellaneous/pageconfig"}
          urlData={{ ...searchParams, ...urlData }}
          extraData={{}}
          onFormSubmit={onFinish}
        />

        <Row gutter={24} justify="center">
          <Col span={24}>
            <ButtonPicker
              submitBtnId={"phantomSpecialQuerySbmt"}
              form={form}
              cancelButtonText={"Reset"}
              formName={"phantomSpecialQueryForm"}
              // marginLeft={btnMargin ? btnMargin : "320px"}
              loading={loading}
              submitButtonText={"Create Exam"}
            //  resetButton={true}
            />
          </Col>
        </Row>
      </div>
    </>
  );
}

export default CreateExamSession;
